import { get, del, post, put } from 'aws-amplify/api';
import { CreateDealerProspectRequest, CreateDealerProspectRequestSchema } from '../models/dealer-prospect.model';
import { getUserToken } from './util.service';

export const createDealerProspect = async (createDealerProspect: CreateDealerProspectRequest) => {
  const userToken = await getUserToken();
  const createDealerProspectBody = mapToRequest(createDealerProspect);
  const response = await post({
    apiName: 'dealerProspects',
    path: '/dealer-prospects',
    options: {
      body: createDealerProspectBody,
      headers: { 'x-auth-token': `Bearer ${userToken}` },
    },
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const getDealerProspect = async (id: string) => {
  const response = await get({
    apiName: 'dealerProspects',
    path: `/dealer-prospects/${id}`,
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const getDealerProspects = async (params: {
  name?: string;
  archived?: boolean;
  lastKey?: string;
  limit?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params.name) queryParams.append('name', params.name);
  if (params.archived !== undefined) queryParams.append('archived', params.archived.toString());
  if (params.lastKey) queryParams.append('lastKey', params.lastKey);
  if (params.limit) queryParams.append('limit', params.limit.toString());

  const response = await get({
    apiName: 'dealerProspects',
    path: `/dealer-prospects?${queryParams.toString()}`,
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

/** Dedicated endpoint for the current user's leads (My Leads). Uses x-auth-token so backend can identify the user. */
export const getMyDealerProspects = async (params?: { limit?: number; lastKey?: string }) => {
  const userToken = await getUserToken();
  const queryParams = new URLSearchParams();
  if (params?.limit) queryParams.append('limit', params.limit.toString());
  if (params?.lastKey) queryParams.append('lastKey', params.lastKey);
  const query = queryParams.toString();
  const path = query ? `/dealer-prospects/mine?${query}` : '/dealer-prospects/mine';
  const response = await get({
    apiName: 'dealerProspects',
    path,
    options: { headers: { 'x-auth-token': `Bearer ${userToken}` } },
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const updateDealerProspect = async (id: string, updateDealerProspect: CreateDealerProspectRequest) => {
  const updateDealerProspectBody = mapToRequest(updateDealerProspect);
  const response = await put({
    apiName: 'dealerProspects',
    path: `/dealer-prospects/${id}`,
    options: { body: updateDealerProspectBody },
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const archiveDealerProspect = async (id: string) => {
  const response = await put({
    apiName: 'dealerProspects',
    path: `/dealer-prospects/${id}/archive`,
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const unarchiveDealerProspect = async (id: string) => {
  const response = await put({
    apiName: 'dealerProspects',
    path: `/dealer-prospects/${id}/unarchive`,
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const deleteDealerProspect = async (id: string) => {
  await del({
    apiName: 'dealerProspects',
    path: `/dealer-prospects/${id}`,
  }).response;

  //   const json = (await response.body.json()) as any;
  //   return json;
};

const mapToRequest = (dealerProspect: CreateDealerProspectRequest): any => {
  const resParse = CreateDealerProspectRequestSchema.safeParse(dealerProspect);
  if (resParse.success) {
    return resParse.data;
  }

  console.log('resParse', resParse.error.issues);
  throw new Error('Validation error');
};
